
<div class="overlay" *ngIf="spinning">
  <div class="center" *ngIf="spinning">
    <mat-progress-spinner *ngIf="spinning" diameter="100" mode="indeterminate">
    </mat-progress-spinner>
  </div>
</div>